<app-breadcrumb [crumbPaths]="[{
        name: 'Home',
        path: '/home'
    }, {
        name: 'Surveys',
        path: '/conduct'
    }, {
        name: surveyName ?? '-',
        path: '/conduct',
        active: true
    }, {
        name: 'New',
        path: '/conduct/details',
        active: true,
        hidden: conductId != null
    }]">
</app-breadcrumb>
<app-loader [isLoading]="isLoading"></app-loader>
<div class="row">
    <div class="col-4">
        <app-page-content>
            <div class="row">
                <div class="col-8">
                    <dx-text-box [(value)]="conductName"></dx-text-box>
                </div>
                <div class="col-4">
                    <div class="float-end ">
                        <dx-button class="me-2 bg-primary" (click)="gridActions({button: { eventName: 'email-link' }})">
                            <i class="fas fa-envelope" aria-hidden="true"></i>
                        </dx-button>
                        <dx-button class="me-2 bg-primary" (click)="gridActions({button: { eventName: 'copy-link' }})">
                            <i class="fas fa-link" aria-hidden="true"></i>
                        </dx-button>
                        <dx-button class="me-2 bg-secondary" (click)="gridActions({button: { eventName: 'archive' }})"
                            *ngIf="!isArchived">
                            <i class="fas fa-archive" aria-hidden="true"></i>
                        </dx-button>
                        <dx-button class="me-2 bg-warning" (click)="gridActions({button: { eventName: 'unarchive' }})"
                            *ngIf="isArchived">
                            <i class="fas fa-archive" aria-hidden="true"></i>
                        </dx-button>
                        <dx-button class="me-2 bg-danger" (click)="gridActions({button: { eventName: 'download' }})">
                            <i class="fas fa-file-pdf" aria-hidden="true"></i>
                        </dx-button>
                        <dx-button *ngIf="!isLocked" class="me-2 bg-primary"
                            (click)="gridActions({button: { eventName: 'save' }})">
                            Save
                        </dx-button>
                    </div>
                </div>
            </div>
        </app-page-content>
        <app-page-content *ngIf="currentUserRole != 'Client'">
            <div class="row">
                <div class="col-8">
                    <ng-container *ngIf="isLocked">Survey has been locked for changes</ng-container>
                </div>
                <div class="col-4">
                    <div class="float-end ">
                        <dx-button *ngIf="!isLocked" class="me-2 bg-secondary"
                            (click)="gridActions({button: { eventName: 'lock' }})">
                            <i class="fa fa-lock" aria-hidden="true"></i>
                        </dx-button>
                        <dx-button *ngIf="isLocked" class="me-2 bg-secondary"
                            (click)="gridActions({button: { eventName: 'unlock' }})">
                            <i class="fa fa-unlock" aria-hidden="true"></i>
                        </dx-button>
                    </div>
                </div>
            </div>
        </app-page-content>
        <app-page-content>
            <ng-container *ngFor="let form of formAndGroupList">
                <div *ngIf="form.group == null; else groupBlock" class="formListItem"
                    [ngClass]="{'selected': form._id == selectedForm?._id}" (click)="gridActions({
                    eventName: 'row-selected',
                    data: form
                })">
                    {{form.name}}
                </div>
                <ng-template #groupBlock>
                    <ng-container *ngTemplateOutlet="groupListBuilder; context: { $implicit: form }">
                    </ng-container>
                </ng-template>
            </ng-container>

            <!-- <app-data-grid [dataSource]="formList" [config]="tableConfig" (dataActionEvent)="gridActions($event)">
            </app-data-grid> -->
        </app-page-content>


    </div>
    <div class="col-8">
        <app-page-content *ngIf="selectedForm">
            <app-form-parser [disabled]="isLocked" [formId]="selectedForm._id"
                (onChangeHandler)="onChangeEmitter($event)" [formState]="formStateService.formState"
                [formConfig]="selectedForm?.parsedFormJson"></app-form-parser>
            <ng-container *ngTemplateOutlet="imagesDiv; context: {
                images: formStateService.getFormImages(selectedForm),
                form: selectedForm
            }"></ng-container>
        </app-page-content>
        <app-page-content *ngIf="selectedGroup">
            <ng-container *ngTemplateOutlet="groupForms;">
            </ng-container>
        </app-page-content>
    </div>
</div>

<ng-template #imagesDiv let-images="images" let-selectedGroup="selectedGroup" let-selectedGroupRow="selectedGroupRow"
    let-form="form">
    <div style="margin: 10px 31px">
        <div class="row" *ngIf="!isLocked">
            <div class="picContainer p-1">
                <input type="file" class="d-none" id="addFile{{selectedGroup?._id}}{{selectedGroupRow}}{{form._id}}"
                    accept="image/png, image/gif, image/jpeg"
                    (change)="onFileSelected($event, selectedGroup, selectedGroupRow, form)" />
                <label for="addFile{{selectedGroup?._id}}{{selectedGroupRow}}{{form._id}}" style="margin-top:35%">
                    <i class="fa-solid fa-plus fa-2xl"></i>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="imageContainer col-md-6" *ngFor="let image of images; let i = index;">
                <div class="row p-2">
                    <div class="col-3">
                        <a href="{{image.url}}" target="_blank">
                            <img src="{{image.url}}" *ngIf="checkExt(image.url); else PdfPlaceHolder" alt=""
                                style="width: 100px; height: 100px">
                            <ng-template #PdfPlaceHolder>
                                <img style="width: 100px; height: 100px" src="assets/document.png">
                            </ng-template>
                        </a>
                    </div>
                    <div class="col-9">
                        <dx-text-box class="w-100" [disabled]="isLocked" [value]="image.comment"
                            (onValueChanged)="onFileComment($event, i, selectedGroup, selectedGroupRow, form)"></dx-text-box>
                        <dx-button *ngIf="!isLocked" type="danger"
                            (onClick)="openImageDeletePopup(i, selectedGroup, selectedGroupRow, form)">Delete</dx-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #groupForms>
    <div class="row" *ngIf="selectedGroupRow != null">
        <div class="col-6">
            <dx-text-box class="mb-2"
                [(value)]="formStateService.formState[selectedGroup._id][selectedGroupRow].name"></dx-text-box>
        </div>
        <div class="col-2">
            <dx-button text="Delete" type="danger"
                (onClick)="openDeleteGroupedSurvey(selectedGroup._id, selectedGroupRow)"></dx-button>
        </div>
    </div>
    <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0" *ngIf="selectedGroupRow != null">
        <ng-container *ngFor="let form of selectedGroup.forms; let i = index">
            <ngb-panel title="{{form.name}}">
                <ng-template ngbPanelContent>
                    <app-form-parser [formId]="form._id" [disabled]="isLocked"
                        (onChangeHandler)="onChangeEmitter($event)"
                        [formState]="formStateService.formState[selectedGroup._id][selectedGroupRow]"
                        [formConfig]="form?.parsedFormJson"></app-form-parser>
                    <ng-container *ngTemplateOutlet="imagesDiv; context: {
                            images: formStateService.getGroupFormImages(selectedGroup, selectedGroupRow, form),
                            selectedGroup, 
                            selectedGroupRow,
                            form
                        }"></ng-container>
                </ng-template>
            </ngb-panel>
        </ng-container>
    </ngb-accordion>
</ng-template>



<ng-template #groupListBuilder let-group>
    <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0">
        <!-- <ng-container *ngFor="let group of groupList"> -->
        <ngb-panel [title]="group.name">
            <ng-template ngbPanelContent>
                <div class="row m-2">
                    <div class="col-12" *ngIf="!isLocked">
                        <dx-button class="me-2 bg-primary float-end" (onClick)="addGroupForm(group)">
                            Add
                        </dx-button>
                    </div>
                    <div class="col-12">
                        <div class="row mt-2">
                            <div class="col-12 grpListRow"
                                *ngFor="let grpInstance of formStateService.formState[group._id]; let i = index;">
                                <div (click)="gridActions({
                                        button: {
                                            eventName: 'select-group'
                                        },
                                        data: group,
                                        row: i
                                    })">
                                    <dx-text-box [(value)]="grpInstance.name"></dx-text-box>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ngb-panel>
    </ngb-accordion>
</ng-template>

<!-- <dx-popup [width]="300" [height]="120" [showTitle]="false" [dragEnabled]="false"
    [hideOnOutsideClick]="true" [showCloseButton]="false" [(visible)]="reportPopup">
    <div *dxTemplate="let data of 'content'">
        <div class="mb-2">
            <dx-button class="w-100" (click)="gridActions({button: { eventName: 'download' }})">Download</dx-button>
        </div>
        <div class="mb-2">
            <dx-button class="w-100" (click)="gridActions({button: { eventName: 'sendEmail' }})">Send Email</dx-button>
        </div>
    </div>
</dx-popup> -->

<app-alert [(visible)]="alertFormDelete.visible" [buttons]="[{
    name: 'Calcel',
    eventName: 'cancel',
    cssClass: 'bg-secondary'
}, {
    name: 'Yes, Proceed',
    eventName: 'okay',
    cssClass: 'bg-danger'
}]" (successHandler)="alertFormDelete.success ? alertFormDelete.success() : onFileDelete()">
    Are you Sure?
</app-alert>